// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--CUFUB","text":"dd31006766--text--RjOuR","close-icon":"dd31006766--close-icon--rb2Qn"};